import { Avatar, Box, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/PendingMemberAccessRow';
import { RowContainerButton } from './MemberAccessRow.styles';

TEXT.DEFINE({
  /** Label for inviting a new user */
  label: 'Invite new user',
});

type PendingMemberAccessRowProps = {
  pendingMemberEmail: string;
};

export function PendingMemberAccessRow({
  pendingMemberEmail,
}: PendingMemberAccessRowProps) {
  return (
    <RowContainerButton
      $isHighlighted={true}
      aria-label={`${TEXT.label} ${pendingMemberEmail}`}
      onMouseDown={(e) => e.preventDefault()}
      type="button"
    >
      <Box alignItems="center" display="inline-flex" width="100%">
        <Box paddingRight={8}>
          <Avatar alt={pendingMemberEmail} background="highlight" />
        </Box>
        <Box
          as={Text}
          color="body"
          paddingRight={8}
          truncate={true}
          variant="body"
        >
          {pendingMemberEmail}
        </Box>
      </Box>
    </RowContainerButton>
  );
}
